import React, { useState } from "react";
import ExportJsonExcel from "js-export-excel";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import statusLogWalletTypeOperation from "../StatusLogWalletTypeOperation";

function LogWallets() {
  const [logWallets, setLogWallets] = useState([]);

  const sendForm = async (e) => {
    e.preventDefault();
    const userID = document.querySelector("#user-id").value;
    const resultSendRequestGetLogWallet = await sendRequestGetLogWallet(userID);

    if (resultSendRequestGetLogWallet === false) {
      return;
    }

    setLogWallets(resultSendRequestGetLogWallet);
  };

  const sendRequestGetLogWallet = async (userID) => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/log-wallet/" + userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTypePayment = (typePayment) => {
    let tagHtml = "";
    switch (typePayment) {
      case true:
        tagHtml = <span className="badge badge-success">افزایش حساب</span>;
        break;

      case false:
        tagHtml = <span className="badge badge-danger">کاهش حساب</span>;
        break;
    }
    return tagHtml;
  };

  const generateTypeOperation = (typeOperation) => {
    return statusLogWalletTypeOperation.statusTypeOperation()[typeOperation];
  };

  const generateTableBody = () => {
    if (logWallets.length < 0) {
      return;
    }

    return logWallets.map((logWallet, index) => {
      return (
        <tr>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(logWallet.low_id)}</td>
          <td>{helpersNumbers.toPersianNum(logWallet.low_user_id)}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(logWallet.low_wallet_before)
            )}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(logWallet.low_wallet_after)
            )}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(logWallet.low_amount)
            )}
          </td>
          <td>{helpersNumbers.toPersianNum(logWallet.low_ref_id)}</td>
          <td>{generateTypePayment(logWallet.low_type_payment)}</td>
          <td>
            <span className="badge badge-primary">
              {generateTypeOperation(logWallet.low_type_operation)}
            </span>
          </td>
          <td dir="ltr">
            {helpersNumbers.toPersianNum(
              helpersTime.convertGregorianToJalali(
                logWallet.low_created_at.split(" ")[0]
              )
            )}{" "}
            {helpersNumbers.toPersianNum(
              logWallet.low_created_at.split(" ")[1]
            )}
          </td>
        </tr>
      );
    });
  };

  const exportReportExcel = (e) => {
    e.preventDefault();
    const option = new Object();
    option.fileName = "لیست وقایع موجود حساب ها";
    let dataExcelFile = logWallets;
    dataExcelFile = [
      {
        1: "#",
        2: "شماره لاگ",
        3: "شماره کاربر",
        4: "موجودی حساب قبل	",
        5: "موجودی حساب بعد	",
        6: "مقدار اعمال شده",
        7: "شماره رجوع",
        8: "نوع تراکنش",
        9: "نوع عملیات",
        10: "تاریخ ثبت",
      },
    ];

    for (const key in logWallets) {
      const logWallet = logWallets[key];

      const createAt =
        helpersNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            logWallet.low_created_at.split(" ")[0]
          )
        ) +
        " " +
        helpersNumbers.toPersianNum(logWallet.low_created_at.split(" ")[1]);

      dataExcelFile = [
        ...dataExcelFile,
        {
          1: helpersNumbers.toPersianNum(parseInt(key) + 1),
          2: helpersNumbers.toPersianNum(logWallet.low_id),
          3: helpersNumbers.toPersianNum(logWallet.low_user_id),
          4: helpersNumbers.toPersianNum(
            helpersNumbers.toFormatFinanceNumber(logWallet.low_wallet_before)
          ),
          5: helpersNumbers.toPersianNum(
            helpersNumbers.toFormatFinanceNumber(logWallet.low_wallet_after)
          ),
          6: helpersNumbers.toPersianNum(
            helpersNumbers.toFormatFinanceNumber(logWallet.low_amount)
          ),
          7: helpersNumbers.toPersianNum(logWallet.low_ref_id),
          8: logWallet.low_type_payment === true ? "افزایش حساب" : "کاهش حساب",
          9: generateTypeOperation(logWallet.low_type_operation),
          10: createAt,
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [7, 7, 7, 7, 7, 7, 7, 10, 7],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="log-wallet-finance" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  ثبت تمامی وقایع موجود حساب ها
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <div className="d-flex align-items-end">
                  <span>
                    <form onSubmit={sendForm} action="">
                      <div className="input-group ">
                        <input
                          type="text"
                          id="user-id"
                          className="form-control"
                          placeholder="شماره کاربر را وارد کنید"
                          required
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            نمایش
                          </button>
                        </div>
                      </div>
                    </form>
                  </span>

                  <span className="pr-2">
                    <button
                      onClick={exportReportExcel}
                      className="btn btn-success"
                    >
                      <span className="pl-2">
                        <i className="fas fa-file-excel"></i>
                      </span>
                      <span>خروجی فایل Excel</span>
                    </button>
                  </span>
                </div>

                <div className="table-responsive pt-3">
                  <table className="table table-hilite tbl-td-white-space">
                    <thead style={{ fontSize: "13px" }}>
                      <tr>
                        <td>#</td>
                        <td>شماره لاگ</td>
                        <td>شماره کاربر</td>
                        <td>موجودی حساب قبل</td>
                        <td>موجودی حساب بعد</td>
                        <td>مقدار اعمال شده</td>
                        <td>شماره رجوع</td>
                        <td>نوع تراکنش</td>
                        <td>نوع عملیات</td>
                        <td>تاریخ ثبت</td>
                      </tr>
                    </thead>
                    <tbody>{generateTableBody()}</tbody>
                  </table>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default LogWallets;
